import { Component, EventEmitter, Input, Output, SimpleChanges, ViewChild, ViewEncapsulation } from '@angular/core';
import { Dropdown } from 'primeng/dropdown';

interface OptionItem {
  name: string;
  value: any;
}

@Component({
  selector: 'caremoni-select-box',
  templateUrl: './select-box.component.html',
  styleUrl: './select-box.component.scss',
  encapsulation: ViewEncapsulation.None
})

export class SelectBoxComponent {
  private static readonly PANEL_MIN_WIDTH = 140;

  @ViewChild('dropdownRef') dropdownRef?: Dropdown;

  @Input() options: any[] = [];
  @Input() selectedValue? : any;
  @Input() id: string = 'select-box';
  @Input() disabled: boolean = false;
  @Input() panelMinWidth: number = 0;
  @Output() valueChange = new EventEmitter<any>();

  @Input()  xdpad?: number = -1;
  @Input()  ydpad?: number = -1;
  @Input()  dpad?: number = -1;
  @Input()  tabdpad?: number = -1;
  @Input()  xtabdpad?: number = -1;
  @Input()  ytabdpad?: number = -1;
  @Input()  scaledpad?: number = -1;

  normalizedOptions: OptionItem[] = [];
  panelStyleValue: { [key: string]: string } = {};

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes['options']) {
      this.normalizedOptions = (this.options || []).map((opt: any) => {
        if (opt && typeof opt === 'object' && 'value' in opt && 'name' in opt) {
          return opt as OptionItem;
        }
        return { name: String(opt), value: opt };
      });
    }
  }

  onChangeValue(value: any): void {
    this.selectedValue = value;
    this.valueChange.emit(value);
  }

  // Panel width defaults to the widest option's content
  onDropdownClick(): void {
    const triggerWidth = this.dropdownRef?.el?.nativeElement?.offsetWidth;
    if (triggerWidth) {
      // sàn 140px không được kéo panel rộng hơn combobox
      const panelMinWidth = Math.min(SelectBoxComponent.PANEL_MIN_WIDTH, triggerWidth);
      // panelMinWidth truyền vào là sàn riêng, mặc định 0 nên không đổi các màn khác
      const panelWidth = Math.max(triggerWidth, this.panelMinWidth);
      this.panelStyleValue = { width: `${panelWidth}px`, minWidth: `${panelMinWidth}px` };
    }
  }

  onDropdownShow(): void {
    // On iPad Safari, tapping this dropdown while the virtual keyboard is
    // still open blurs the previous input and closes the keyboard. PrimeNG
    // positions the overlay once, synchronously, using the trigger's
    // getBoundingClientRect() at click time — before the keyboard-close
    // reflow finishes moving the trigger back to its resting position — and
    // it skips its own resize-based realign on touch devices. Re-align once
    // the keyboard-close animation has settled.
    const isIPad = /iPad|Macintosh/.test(navigator.userAgent) && navigator.maxTouchPoints > 1;
    if (!isIPad) {
      return;
    }
    setTimeout(() => {
      this.dropdownRef?.overlayViewChild?.alignOverlay();
    }, 100);
  }
}
